import {
  CLEAR_SESSION,
  CLEAR_SELECTED_OBJECTS
} from 'constants/ActionTypes';

export const clearSession = () => {
  return {
      type: CLEAR_SESSION,
  };
};
export const clearSelectedObjects = () => {
  return {
      type: CLEAR_SELECTED_OBJECTS,
  };
};



// WEBPACK FOOTER //
// ./actions/session.js